import React from "react";

const MoneyFormatter = (props: any) => {

    const {
        value,
        locale = "es-ES",
        style = "decimal", // "decimal" | "currency" | "percent"
        currency = "MXN",
        minimumFractionDigits = 0,
        maximumFractionDigits = 2,
        prefix = '$ '
    } = props;

    if (value === null || value === undefined || isNaN(value)) {
        return <span>-</span>;
    }

    const formattedNumber = new Intl.NumberFormat(locale, {
        style,
        currency: style === "currency" ? currency : undefined,
        minimumFractionDigits,
        maximumFractionDigits,
        useGrouping: true, // fuerza separador de miles
    }).format(value);

    return <>{prefix}{formattedNumber}</>;
};

export default MoneyFormatter;